import { SyntheticEvent, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getBrand, createBrand } from "../../redux/brandSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, TextField } from "@mui/material";
import React from "react";
import { Brand } from "../../model/brand.model";
import { BrandsService } from "../../service/brands.service";
//import { isNumber } from "lodash";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { ToastContainer, toast } from "react-toastify";

function StockUpload(this: any) {
  const params = useParams();
  const brandId = params.brandid;
  const dispatch = useDispatch();
  const { brand } = useSelector((state: any) => state.brandSlice);
  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState<string[]>([]);
  const [status, setStatus] = useState(1);
  const [brandName, setBrandName] = useState("");
  const [selectedBrandId, setSelectedBrandId] = React.useState("");
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const brandsService = new BrandsService();

  const [brandImage, setbrandImage] = useState("");
  const [brandImageData, setbrandImageData] = useState("");
  const [errMsg, setErrMsg] = useState('');
  const [isedit, setIsEdit] = React.useState(true);
  const location = useLocation();

  const loadAllBrands = () => {

    brandsService.brands(-1).then(data => {
      const res = data.data;
      setAvailableBrands(res);

    });
  }

  let parameters = {}
  let iscalled = false;
  useEffect(() => {
    //console.log("+++++++++++++++selectedBradId : " + selectedBrandId)
    if (!iscalled) {
      iscalled = true


      if (location != null && location.state != null && location.state.brandDetails != null) {
        parameters = location.state.categoryDetails;

        console.log("params ", parameters)

        setSelectedBrandId(location.state.brandDetails.brandId)
        setBrandName(location.state.brandDetails.brandName)
        setbrandImage(((location.state.brandDetails.brandImage).split("/").pop()))
        setStatus(location.state.brandDetails.status)
        setIsEdit(false)

      }
    }
  }, []);

  const onChangePicture = (e: any) => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      // setImgData(URL.createObjectURL(e.target.files[0]));
    }
  };


  const [submitClick, setsubmitClick] = React.useState(false);
  const createNewBrand = () => {

    if (brandName == "" || brandName == null || brandImage == "" || brandImage == null) {
      setsubmitClick(true)
      return
    }

    const data = {
      "brandId": selectedBrandId,
      "status": status,
      "brandName": brandName,
      "brandImage": brandImage,
      "brandImageData": brandImageData
    };
    brandsService.createBrand(data).then((res: any) => {
      toast.success('Product created successfully', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate('../brands');
    }).catch((err: any) => {
      console.log('err ', err);
      setErrMsg('Something went wrong while creating the product');
    });

  }

  const onUploadBrandImg = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];
      console.log("^^^Cad^^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {

        setbrandImage(file.name);

        setbrandImageData(reader.result as string);

      }
      reader.onerror = (e) => { console.log('err') }
    }
  }

  return (
    <div className="App">
      <div className="card m-8">

        <div className="card-body ">

          <div className="row pt-4">


       

            <div className='col-md-4 text-left'>


              <div className="form-group ">
                <TextField disabled size="small" label="Stock File (CSV)" id="outlined-start-adornment" inputProps={{ accept: "application/pdf" }} InputLabelProps={{ shrink: true }} variant="outlined" type="text"
                  className="form-control" name='cad' value={brandImage}
                  error={submitClick && (brandImage == "" || brandImage == null)  }
                  InputProps={{
                    sx: { height: 30 },
                    endAdornment: (
                      <IconButton component="label"  disabled >
                        <FileUploadOutlinedIcon  />
                        <input style={{ display: "none" }} type="file" accept="image/png,image/jpeg,image/jpg" hidden onChange={(event) => onUploadBrandImg(event)} name="cadFileHiddenImg"
                        />
                      </IconButton>
                    ),
                  }}
                />
              </div>

            </div>

          

          </div>
        </div>
        <div className="card-footer col-12 text-center">
          <Button style={{ color: "green" }} className="mr-4" onClick={() => createNewBrand()} variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
            Submit
          </Button>
          <Button style={{ color: "red" }} className="ml-4" onClick={() => navigate('../brands')} variant="text" startIcon={<ClearOutlinedIcon />}>
            Cancel
          </Button>
        </div>
      </div>

      <ToastContainer

        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

    </div>
  );
}

export default StockUpload;
